import React from 'react'

import type { ButtonProps } from './Button/Button'
import { Button } from './Button/Button'

export function ButtonSubmit(props: Omit<ButtonProps, 'href' | 'type'>) {
  return <Button {...props} type="submit" />
}
